import Utility from '../../../src/core/Utility.js';

class SelectDataSourceController {
	constructor($scope, $attrs, $translate, $filter) {
		this.scope = $scope;
		this.queryResult = [];
		this.$filter = $filter;
		this.$translate = $translate;

		if($attrs.readonly === '' || $attrs.readonly) {
			this.isReadOnly = true;
		}
		else {
			this.isReadOnly = false;
		}
	}

	selectContext(item, e) {
		e.stopPropagation();
		if(!item) {
			unselectContext();
			return;
		}
		this.ngModelController.$setViewValue(item);
		this.scope.onSelect({
			$item: item
		});
	}

	unselectContext() {
		this.ngModelController.$setViewValue(null);
		this.scope.onSelect({
			$item: null
		});
	}

	onChangeHandler() {
		// 데이터소스가 변경되면 부모 프리셋을 저장해야하는데, 이를 위해 scope 간 통신
		this.scope.$emit('DashboardContainerController:onDataSourceChange', this.scope.store);
		this.scope.onChange({});
	}

	openDataSourceModal(item = { name: '', guid: 'NEW_DATASOURCE' }) {
		this.scope.$emit('SelectDataSourceController:openDataSourceModal', item);
	}

	confirmDeleteDataSource(item) {
		var delMsg = this.$filter('translate')('$S_msg_ConfirmDeleteDataSource');
		var isok = confirm(delMsg);
		if(isok) {
			this._deleteDataSource(item);
		}
	}

	_deleteDataSource(item) {
		if(this.selectedSource === item) {
			this.unselectContext();
		}
		this.scope.store.deleteSource(item.guid);
		this.ngModelController.$setViewValue(null);
		this.onChangeHandler();
	}
}

export default SelectDataSourceController;


// WEBPACK FOOTER //
// ./resources/WEB-INF/package/system/dashboard/SelectDataSourceController.js